import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { History, Pencil, Trash2, ChevronDown, ChevronUp } from 'lucide-react';

const LightEditAuditSection = ({ entries = [], defaultOpen = false }) => {
  const { t, i18n } = useTranslation('orders');
  const [open, setOpen] = useState(defaultOpen);

  if (!entries || entries.length === 0) return null;

  const formatDate = (date) => {
    if (!date) return '';
    try {
      return new Date(date).toLocaleString(i18n.language === 'el' ? 'el-GR' : 'en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
    } catch {
      return String(date);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border mt-4">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between px-4 py-2.5 hover:bg-gray-50 rounded-lg transition-colors"
      >
        <div className="flex items-center gap-2">
          <History className="w-4 h-4 text-sky-600" />
          <h3 className="text-sm font-semibold text-gray-900">
            {t('simpleOrders.lightEdit.auditTitle', 'Edit history')}
          </h3>
          <span className="text-xs text-gray-500 bg-gray-100 rounded-full px-2 py-0.5">
            {entries.length}
          </span>
        </div>
        {open ? (
          <ChevronUp className="w-4 h-4 text-gray-400" />
        ) : (
          <ChevronDown className="w-4 h-4 text-gray-400" />
        )}
      </button>

      {open && (
        <div className="px-4 pb-4 pt-1 border-t">
          <ul className="space-y-3 mt-3">
            {entries.map((entry, idx) => (
              <li key={idx} className="border-l-2 border-sky-200 pl-3 py-1">
                <div className="flex items-center justify-between text-xs text-gray-500 mb-1">
                  <span>
                    {entry.editorName || t('simpleOrders.lightEdit.unknownEditor', 'Wholesaler')}
                  </span>
                  <span>{formatDate(entry.editedAt)}</span>
                </div>
                <ul className="space-y-0.5">
                  {(entry.changes || []).map((c, cIdx) => (
                    <li key={cIdx} className="flex items-start gap-2 text-sm text-gray-700">
                      {c.removed ? (
                        <Trash2 className="w-3.5 h-3.5 text-red-500 mt-0.5 flex-shrink-0" />
                      ) : (
                        <Pencil className="w-3.5 h-3.5 text-sky-500 mt-0.5 flex-shrink-0" />
                      )}
                      <span className="font-medium">{c.name}</span>
                      <span className="text-gray-500">
                        {c.removed
                          ? t('simpleOrders.lightEdit.removed', 'Removed')
                          : `${c.prevQty} → ${c.newQty}`}
                      </span>
                    </li>
                  ))}
                </ul>
                {entry.reason && (
                  <p className="mt-1 text-xs text-gray-500 italic">"{entry.reason}"</p>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default LightEditAuditSection;
